import {AxiosPromise} from 'axios';

import {BRONTO} from 'constants/actions';
import {ENDPOINTS} from 'constants/endpoints';
import {HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'constants/api';
import {ActionType} from '@typescript/common/actionTypes';
import {instanceGusaBackend} from 'libs/api';

/**
 * Sending an email to the Bronto to associate it with a customer
 * @param {string} emailAddress Current email
 * @returns {ActionType<AxiosPromise>} Action
 */
export function emailCapture(emailAddress: string): ActionType<AxiosPromise> {
    return {
        type: BRONTO.EMAIL_CAPTURE,
        payload: instanceGusaBackend({
            method: 'post',
            url: ENDPOINTS.BRONTO_EMAIL_CAPTURE,
            params: {
                emailAddress,
            },
        }),
    };
}

/**
 * Sending an email to the Bronto to subscribe a customer
 * @param {string} email - Email
 * @returns {ActionType<AxiosPromise>} Action
 */
export function subscribe(email: string): ActionType<AxiosPromise> {
    return {
        type: BRONTO.SUBSCRIBE,
        payload: instanceGusaBackend({
            method: 'put',
            headers: {
                [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                    HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.APPLICATION_JSON,
            },
            url: ENDPOINTS.BRONTO_SUBSCRIBE,
            data: {
                email,
            },
        }),
    };
}
